import http from "@/http";
//### 门票计划列表
// https://zs.xzu.ink/api/ticket_plan/list
export const getTicketPlan = {
  p: "/api/ticket_plan/list",
  r: data => {
    return http({
      url: "/api/ticket_plan/list",
      method: "post",
      data
    });
  }
};
//### 添加门票计划
// https://zs.xzu.ink/api/ticket_plan/add
export const addTicketPlan = {
  p: "/api/ticket_plan/add",
  r: data => {
    return http({
      url: "/api/ticket_plan/add",
      method: "post",
      data
    });
  }
};
//### 门票计划详情
// https://zs.xzu.ink/api/ticket_plan/details/2
export const getTicketPlanInfo = {
  p: "/api/ticket_plan/details",
  r: data => {
    return http({
      url: "/api/ticket_plan/details/" + data.id,
      method: "get"
      // data
    });
  }
};
//### 修改门票计划
// https://zs.xzu.ink/api/ticket_plan/edit
export const editTicketPlan = {
  p: "/api/ticket_plan/edit",
  r: data => {
    return http({
      url: "/api/ticket_plan/edit",
      method: "post",
      data
    });
  }
};
//### 删除门票计划
// https://zs.xzu.ink/api/ticket_plan/delete
export const deleteTicketPlan = {
  p: "/api/ticket_plan/delete",
  r: data => {
    return http({
      url: "/api/ticket_plan/delete",
      method: "post",
      data
    });
  }
};
